<style lang="less" scoped>
  @import './OrderDetail.less';
</style>
<template>
  <div style="width:1100px;margin:0 auto;overflow-x:auto;">
    <div slot="header" class="member-order-header">
      <h2>订单详情</h2>
    </div>
    <el-card>
      <div slot="header" class="member-order-info-header">
        <div>订单基本信息</div>
        <div>收货人信息</div>
        <div>发票信息</div>
      </div>
      <div class="member-order-info">
        <div class="member-order-info-list">
          <div class="member-order-info-list-item">
            订单编号：{{order.orderSn}}
          </div>
          <div class="member-order-info-list-item">
            订单状态：{{getOrderStatus(order)}}
          </div>
          <div class="member-order-info-list-item">
            支付方式：{{$enums.payments.label(order.payMethod)}}
          </div>
          <div class="member-order-info-list-item">
            物流公司：{{expressInfo.expressName}}
          </div>
        </div>
        <div class="member-order-info-list">
          <div class="member-order-info-list-item">
            收货人：{{order.consignee}}
          </div>
          <div class="member-order-info-list-item">
            收货地址：{{order.region}}{{order.address}}
          </div>
          <div class="member-order-info-list-item">
            手机：{{order.mobile}}
          </div>
        </div>
        <div class="member-order-info-list">
          <div class="member-order-info-list-item">
            发票类型：个人 电子发票
          </div>
          <div class="member-order-info-list-item">
            发票抬头：{{order.consignee}}
          </div>
          <div class="member-order-info-list-item">
            发票内容：产品明细
          </div>
          <div class="member-order-info-list-item" v-if="order.orderStatus != $enums.orderStatus.CANCELLED && orderInvoice.invoiceExportUrl != ''">
            已开票：<a target="_blank" class="member-order-invoice-url"  :href="orderInvoice.invoiceExportUrl">【查看发票】</a>
          </div>
        </div>
      </div>
    </el-card>
    <el-card>
    <div slot="header" class="member-order-info-header">
      <div>物流信息</div>
    </div>
    <div class="member-order-express-info" v-if="checkExpressInfo()">
      <div class="member-order-express-number">
        {{expressInfo.expressName}}&nbsp;&nbsp;&nbsp;快递单号：{{expressInfo.expressNumber}}
      </div>
      <div class="member-order-express-list">
        <div class="member-order-express-list-item"  v-for="(express, index) of expressInfo.trackInfo" :key="index">
          <div class="member-order-express-item-line"></div>
          <div class="member-order-express-item-dot"></div>
          <div class="member-order-express-item-content">
            <div class="member-order-express-remark">{{express.remark}}</div>
              <div class="member-order-express-time">{{express.time}}</div>
            </div>
          </div>
      </div>
    </div>
    <div class="member-order-express-info" v-else>
      暂时没有快递日志记录
    </div>
    </el-card>
    <div class="member-order">
      <el-card>
        <div class="member-order-product-list-header"  slot="header">
          <div class="order-product-list-header">
            <div class="order-product-detailed">商品清单</div>
            <div class="order-product-number">数量</div>
            <div class="order-product-price">单价</div>
          </div>
          <div class="order-handle">操作</div>
        </div>
        <div class="member-order-list">
          <div class="order-product-list">
            <div class="order-product-item" v-for="(orderProduct, index) of order.orderProducts" :key="index">
              <div class="order-product-detailed">
                <img :src="orderProduct.image" class="order-product-image" alt="">
                <div>{{orderProduct.productName}}</div>
              </div>

              <div class="order-product-number">
                {{orderProduct.number}}
              </div>
              <div class="order-product-price">
                ¥{{orderProduct.salePrice}}
              </div>
            </div>
          </div>
          <div class="order-payment">
            <el-button type="primary" :disabled="disable"  @click="payOrder(order)"  v-if="showOrderPayment(order)">
              付款 <span>{{cancelTimeDesc}}</span>
            </el-button>
            <el-button type="text"  v-if="showOrderPayment(order)" @click="cancelOrder(order, false)" >
              取消订单
            </el-button>
          </div>
        </div>
      </el-card>
      <div class="order-cost-information">
        <div class="order-cost-information-header">费用信息</div>
        <div>商品金额：¥{{order.productAmount}} + 配送费：¥{{order.shippingAmount}} = 订单金额：¥{{order.orderAmount}}  已支付：¥{{order.payStatus == $enums.payStatus.PAID ? order.orderAmount : '0.00'}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import _ from 'lodash';
  import {payOrder, getOrderStatus} from "@/helpers/index";

  const { mapState: authMapState } = createNamespacedHelpers('auth')
  export default {
    name: 'OrderDetail',
    data() {
      return {
        order: {},
        cancelTime:0,
        cancelTimeDesc:'',
        expressInfo: {
          'trackInfo' : [],
          'expressName' : '',
          'expressNumber' : '',
        },
        disable:false,
        orderInvoice: {
          'invoiceExportUrl': ''
        }
      }
    },

    methods: {
      checkExpressInfo() {
        if(this.expressInfo.trackInfo && this.expressInfo.trackInfo.length > 0) {
          return true;
        }
        return false;
      },
      getOrderStatus(order) {
        return getOrderStatus(this.$enums, order)
      },
      payOrder(order) {
        payOrder(this.$router, order)
      },

      /**
       * 获取订单
       */
      async getOrder(id) {
        this.order = await this.$store.dispatch('orders/document', id);
        this.order = this.order.document
        if(this.order.shippingStatus ==  this.$enums.shippingStatus.SHIPPED){
          this.expressInfo = await this.$store.dispatch('express/document', {orderId:id});
        }
        this.getOrderInvoice();
        this.handleOrderCancelTime()
      },

      /**
       *  获取订单的发票信息
       */
      getOrderInvoice() {
        const orderInvoices = this.order.orderInvoices.reverse();
        for(var orderInvoice of orderInvoices) {
          if(orderInvoice.invoiceType == 'blue') {
            this.orderInvoice = orderInvoice;
            return;
          }
        }
      },

      /**
       * 是否显示支付链接
       */
      showOrderPayment(order) {
        if(order.orderStatus == this.$enums.orderStatus.CANCELLED || order.orderStatus == this.$enums.orderStatus.COMPLETED || order.payStatus == this.$enums.payStatus.PAID) {
          return false;
        }else {
          return true;
        }
      },

      /**
       * 取消订单
       */
      async cancelOrder(order, isConfirm) {
        if(!isConfirm) {
          await this.$confirm('是否确认取消订单?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          })
        }
        await this.$store.dispatch('order/cancel', { id:order.id });
      },

      /**
       * 处理订单自动关闭时间
       */
      handleOrderCancelTime() {
        let order = this.order
        let orderCancelTime = parseInt(this.order.activity.cancelTime) * 60 * 1000
        if(orderCancelTime == 0 || order.orderStatus != this.$enums.orderStatus.UNSETTLED){
          this.cancelTimeDesc = '';
          return;
        }

        setInterval(this.getOrderCancelTime,1000)

      },

      /**
       * 订单自动关闭时间
       */
      getOrderCancelTime(){
        let order = this.order
        let orderCancelTime = parseInt(this.order.activity.cancelTime) * 60 * 1000
        if(this.cancelTime != 0) {
          orderCancelTime = this.cancelTime--;
        }else{
          let currentTime =  new Date().getTime();
          let orderCreateTime = new Date(order.createdAt).getTime()
          orderCancelTime = parseInt(orderCancelTime)-(currentTime-orderCreateTime)

          if(orderCancelTime <= 0) {
            this.cancelTimeDesc = ''
            this.cancelTime = 0
            this.disable = true;
            return
          }
          orderCancelTime = orderCancelTime/1000
          this.cancelTime = parseInt(orderCancelTime)
        }

        let minutes = parseInt(orderCancelTime / 60)
        let seconds = parseInt(orderCancelTime % 60)

        minutes = minutes < 10 ? '0' + minutes : minutes
        seconds = seconds < 10 ? '0' + seconds : seconds

        this.cancelTimeDesc = minutes + ":" + seconds;
      },
    },
    mounted() {
      const orderId = this.$route.params.id
      this.getOrder(orderId);
    },
    updated() {
    },
    computed : {

    },
    watch : {

    }
  };
</script>


